export const MAX_RAW_VIDEO_DURATION_SEC = 5 * 60;
const RAW_VIDEO_DURATION_SLACK_SEC = 2;
export const RAW_VIDEO_TOO_LONG_MESSAGE = 'Videos must be 5 minutes or shorter.';

export function isRawVideoTooLong(durationSec) {
    const d = Number(durationSec);
    return Number.isFinite(d) && d > MAX_RAW_VIDEO_DURATION_SEC + RAW_VIDEO_DURATION_SLACK_SEC;
}

/** Browser metadata duration in seconds, or null if the file cannot be probed. */
export function readVideoFileDurationSec(file) {
    return new Promise((resolve) => {
        if (!file || typeof document === 'undefined') {
            resolve(null);
            return;
        }
        const url = URL.createObjectURL(file);
        const video = document.createElement('video');
        video.preload = 'metadata';
        const finish = (value) => {
            URL.revokeObjectURL(url);
            video.removeAttribute('src');
            video.load();
            resolve(value);
        };
        video.onloadedmetadata = () => {
            const d = video.duration;
            finish(Number.isFinite(d) && d > 0 ? d : null);
        };
        video.onerror = () => finish(null);
        video.src = url;
    });
}
